export default "__VITE_ASSET__0ABZeigc__"